/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import React from 'react';

import {
  Button,
  Checkbox,
  type CheckboxProps,
  Form,
  Grid,
  Modal,
} from '@mairistem/composants';

interface ModalEditionListesProps {
  edition: Date;
  loading: boolean;
  isClotured?: boolean;
  onEdition: ({
    recenses,
    nonRecenses,
  }: {
    recenses: boolean;
    nonRecenses: boolean;
  }) => void;
  onClose: () => void;
}

const ModalEditionListes = (props: ModalEditionListesProps) => {
  const { edition, loading, isClotured = false, onEdition, onClose } = props;

  const [visualisationLoading, setVisualisationLoading] =
    React.useState<boolean>(false);
  const [recenses, setRecenses] = React.useState<boolean>(false);
  const [nonRecenses, setNonRecenses] = React.useState<boolean>(false);

  React.useEffect(() => {
    if (!loading) {
      setVisualisationLoading(false);
    }
  }, [loading]);

  const handleVisualisation = React.useCallback(() => {
    setVisualisationLoading(true);
    onEdition({ recenses, nonRecenses });
  }, [nonRecenses, onEdition, recenses]);

  const isVisualisationDisabled = React.useMemo(
    () => loading || isClotured || (!recenses && !nonRecenses),
    [loading, isClotured, recenses, nonRecenses],
  );

  return (
    <Modal closeIcon open onClose={onClose} size="small">
      <Modal.Header>Édition des listes de recensement</Modal.Header>
      <Modal.Content>
        <Grid>
          <Grid.Row>
            <Grid.Column width={8}>
              <Form.Checkbox
                data-testid="modal-edition-listes-checkbox-recenses"
                label="Liste des recensés"
                checked={recenses}
                onChange={(
                  _e: React.FormEvent<HTMLInputElement>,
                  data: CheckboxProps,
                ) => setRecenses(data.checked || false)}
                disabled={isClotured}
              />
            </Grid.Column>
            <Grid.Column width={8}>
              <Checkbox
                data-testid="modal-edition-listes-checkbox-non-recenses"
                label="Liste des non recensés"
                checked={nonRecenses}
                onChange={(
                  _e: React.FormEvent<HTMLInputElement>,
                  data: CheckboxProps,
                ) => setNonRecenses(data.checked || false)}
                disabled={isClotured}
              />
            </Grid.Column>
          </Grid.Row>
          {edition && (
            <Grid.Row style={{ paddingTop: '2em' }}>
              <Grid.Column width={16}>
                {edition ? (
                  <p>
                    <i>
                      Dernière édition des listes de recensement effectuée le
                      {` ${edition.toLocaleDateString()}`}
                    </i>
                  </p>
                ) : (
                  <p>
                    <i>Édition des listes de recensement non effectuée</i>
                  </p>
                )}
              </Grid.Column>
            </Grid.Row>
          )}
        </Grid>
      </Modal.Content>
      <Modal.Actions>
        <Button
          basic
          size="small"
          icon="close"
          content="Annuler"
          onClick={onClose}
        />
        <Button
          data-testid="modal-edition-listes-bouton-visualiser"
          content="Visualiser"
          color="green"
          onClick={handleVisualisation}
          loading={visualisationLoading}
          disabled={isVisualisationDisabled}
        >
          Visualiser
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default ModalEditionListes;
